import { useHistory } from '@fs/zion-router'
import React, { useMemo, useState } from 'react'
import { Autosuggest } from '@fs/zion-ui'
import { MenuSearch } from '@fs/zion-icon'
import { usePlaceReportsPageData } from '../../PlaceReportsProvider'
import { getLocaleName } from '../../placeReportsHelper'

export default function ReportsSearch() {
  const { reportsIndex } = usePlaceReportsPageData()
  const { regions } = reportsIndex || {}
  const history = useHistory()
  const [selectedItem, setSelectedItem] = useState(null)

  const suggestions = useMemo(() => {
    const accum = []
    regions?.forEach((region) => {
      const regionName = getLocaleName(region?.name)
      accum.push({
        key: `region-${region.id}`,
        primaryText: `${regionName}`,
        region,
        path: `?region=${region.id}`,
      })
      region?.countries?.forEach((country) => {
        const countryName = getLocaleName(country?.name, country?.native_lang)
        accum.push({
          key: `country-${country.id}`,
          primaryText: `${countryName}`,
          secondaryText: `${regionName}`,
          country,
          region,
          path: `?region=${region.id}&country=${country.id}`,
        })
        country?.divisions?.forEach((division) => {
          const divisionName = getLocaleName(division?.name, country?.native_lang)
          accum.push({
            key: `division-${division.id}`,
            primaryText: `${divisionName}`,
            secondaryText: `${countryName}`,
            tertiaryText: `${regionName}`,
            division,
            country,
            region,
            path: `?region=${region.id}&country=${country.id}&division=${division.id}`,
          })
        })
      })
    })

    return accum
  }, [regions])

  return (
    <Autosuggest
      aria-label="Place Reports Search"
      highlightMatchingText
      selectedItem={selectedItem}
      Icon={MenuSearch}
      suggestions={suggestions}
      placeholder="Enter a place name"
      onSuggestionSelected={(suggestion) => {
        if (suggestion) {
          history.push(suggestion.path)
          setSelectedItem(null)
        }
      }}
      clearable
    />
  )
}
